import React, { useState, useEffect } from "react";

import Gmailicon from "../assets/img/gmail.png";
import Phoneicon from "../assets/img/phone.png";
import SeoHelmet from "../components/SeoHelmet";

import Video1 from "../assets/video/video1.mp4";
import Video2 from "../assets/video/video2.mp4";
import Video3 from "../assets/video/video3.mp4";

import Playbtn from "../assets/img/courses/play.png";

import Image1 from "../assets/img/courses/img1.jpg";
import Image2 from "../assets/img/courses/img2.jpg";
import Image3 from "../assets/img/courses/img3.jpg";

import Bgimg from "../assets/img/courses/bg.jpg";
import Bhavimg from "../assets/img/styling/img1.png";

import Bhavimg3 from "../assets/img/styling/img3.png";
import iconstrt from "../assets/img/iconstartt.png";
import Testibg from '../assets/img/Collection.jpg';
import Testiimg from '../assets/img/ImageWithFallback.jpg';
import Bhavimg2 from "../assets/img/courses/img2.png";
import Bhavimg4 from "../assets/img/styling/img2.png";
import Testiimg1 from '../assets/img/courses/testi1.jpg';
import Testiimg2 from '../assets/img/courses/testi2.jpg';
import Testiimg3 from '../assets/img/courses/testi3.jpg';
import Testiimg4 from '../assets/img/courses/testi4.jpg';
const Stylingwithbhavna = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    if (window.Swiper) {
      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      });
    }
  }, []);

  const handleRazorpayPayment = async (courseType) => {
    if (!formData.name.trim()) {
      alert("Please enter your name.");
      return;
    }
    if (!formData.email.trim()) {
      alert("Please enter your email.");
      return;
    }
    if (!formData.phone.trim()) {
      alert("Please enter your phone number.");
      return;
    }

    const amount =
      courseType === "online"
        ? 50000
        : courseType === "offline"
        ? 100000
        : 200000;
    const description =
      courseType === "online"
        ? "Online Course"
        : courseType === "offline"
        ? "Offline Course"
        : "Only Offline Course";

    // 1. Create Razorpay Order from your PHP
    let orderId = null;
    try {
      const response = await fetch(
        "https://thebhavanasingh.com/create_order.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: amount * 100 }), // amount in paise
        }
      );
      const data = await response.json();

      console.log("Create Order Response:", data);

      if (!data || !data.id) {
        alert("Failed to create Razorpay order.");
        return;
      }

      orderId = data.id;
    } catch (error) {
      console.error("Order creation error:", error);
      alert("Something went wrong while creating the order.");
      return;
    }

    // 2. Open Razorpay Checkout
    const options = {
      key: "rzp_live_meaLkJIwJaMl5q", // Your Razorpay Key ID
      amount: amount * 100,
      currency: "INR",
      name: "Bhavana Singh Courses",
      description: description,
      order_id: orderId, // ✅ VERY IMPORTANT
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.phone,
      },
      notes: {
        address: "Bhavana Singh",
      },
      theme: {
        color: "#3399cc",
      },
      handler: function (response) {
        console.log("Payment Success Response:", response);
        window.location.href = `/success?payment_id=${response.razorpay_payment_id}`;
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.on("payment.failed", function (response) {
      console.error("Payment Failed:", response.error);
      alert(`Payment failed: ${response.error.description}`);
    });

    razorpay.open();
  };

  return (
    <>
      <SeoHelmet
  title="Personal Styling & Bridal Trousseau Services | Bhavana Singh"
  description="Explore personal styling, bridal trousseau planning, and wardrobe cleansing by Bhavana Singh. Feel confident, clear, and effortlessly styled every day"
  
/>
      <section className="courses_head">
        <img src={Bgimg}></img>
      </section>
 <section className="twoweeksss twooo">
         <div className="container mbr_row_coss">
           <div className="mbr_row_co">
            <img className="icon111" src={Bhavimg2}></img>
            <h2>Our<br></br>Servises</h2>
           </div>
         </div>
      </section>
      <section className="twoweek stylin_first">
        <div className="container">
          <div className="mbr_row">
             <div className="imagepartt">
              <img src={Bhavimg}></img>
            </div>
            <div className="content_section">
              <h2>
                The Bridal Trousseau &<br></br> Styling
              </h2>
              <span className="subheding_tex">
                For Brides Who Want to Feel<br></br> Ready, Not Rushed
              </span>
              <p>
                Bhavana Singh is a Personality & Image Transformation Coach who has transformed 1000+ lives, working with both men and women to build confidence and self-belief from within. Beyond being a well-known stylist and TEDx speaker, she focuses on how people think, speak, and carry themselves. Through personality coaching, body language training, grooming, public speaking, and pageant guidance, she helps individuals develop a strong, impactful presence.
              </p>
              
              <div className="btngroup">
                <a
                  href="/the-bridal-trousseau-styling"
                  className="terrs_btn"
                >
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                {/* <a
                  href="#"
                  data-bs-toggle="modal"
                  className="terrs_btn"
                  data-bs-target="#offlineonlyCourseModal"
                >
                  <img src={iconstrt} alt="" />
                  ENROLL NOW
                </a> */}
              </div>
            </div>
           
          </div>
        </div>
      </section>
      <section className="oneweek onemonth">
        <div className="container">
          <div className="mbr_row">
            
            <div className="content_section">
              <h2>
                One-Month Personal Styling<br></br> Transformation
              </h2>
              <span className="subheding_tex">30 Days. Clear, Unique Style.<br></br> Confident You.</span>
              <p>
               This personal styling transformation helps you feel confident, put-together, and in control of how you show up every day. You learn how to dress in a way that suits your body, lifestyle, and goals, so you can own every space you walk into. By the end, you feel clearer, stronger, and more comfortable being seen—at work, socially, and in your personal life.
              </p>
             
              <div className="btngroup">
                <a
                  href="/one-month-styling-transformation"
                  className="terrs_btn"
                >
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                {/* <a
                  href="#"
                  data-bs-toggle="modal"
                  className="terrs_btn"
                  data-bs-target="#offlineCourseModal"
                >
                  <img src={iconstrt} alt="" />
                  ENROLL NOW
                </a> */}
              </div>
            </div>
            <div className="imagepartonee">
              <img src={Bhavimg4}></img>
            </div>
          </div>
        </div>
      </section>

      <section className="lastpartonsite styling_laastpart">
        <div className="container">
          <div className="mbr_row">
             <div className="imageparttt">
              <img src={Bhavimg3}></img>
            </div>
            <div className="content_section">
              <h2>
                On-Site Wardrobe Cleansing
              </h2>
              <span className="subheding_tex">
                For Those With a Full Wardrobe, Yet Nothing to Wear
              </span>
              <p>
                Have a full wardrobe but nothing to wear? Bhavana restructures your existing wardrobe, refining and organizing it to create a unique, intentional look just for you. Enjoy effortless dressing, outfits that reflect your personality and lifestyle, and a closet that truly works for your daily life. Feel the weight lift off your shoulders as your wardrobe becomes lighter, stress-free, and a source of calm and clarity every day.
              </p>
              
              <div className="btngroup">
                <a
                  href="/wardrobe"
                  className="terrs_btn"
                >
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                {/* <a
                  href="#"
                  data-bs-toggle="modal"
                  className="terrs_btn"
                  data-bs-target="#offlineonlyCourseModal"
                >
                  <img src={iconstrt} alt="" />
                  ENROLL NOW
                </a> */}
              </div>
            </div>
           
          </div>
        </div>
      </section>

       <section className='testimonal_part' style={{ backgroundImage: `url(${Testibg})` }}>
        <div className="container">
          
            <h4>testimonials</h4>
            <h2>Incredible Transformation Stories<br></br>that Will Shock You</h2>
            <p>Real stories and honest experiences from women who have trained with<br></br> Bhavana. See how confidence, style, and self-belief have changed their lives.</p>

            <div className='testimonal_box'>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg1}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                  
                  {/* <h5>“Instant confidence boost. Exactly what I needed.”</h5>
                  <span>— Ananya</span> */}
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg2}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg3}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg4}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
            </div>
             <a href="/about-us" className="terrs_btn test_btn">
                <img src={iconstrt} alt="" />
                VIEW ALL 
              </a>
              
        </div>
    </section>

      {/* <section className="transform trnscur">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>Transform With Bhavana – 2-Week Intensive Program Redefine Who You Are—Relaunch Where You’re Headed.</h3>
                <p>
                Led by renowned Personality & Image Transformation Coach Bhavana Singh, this premium 2-week offline course is a holistic program designed to help you step into your most confident, stylish, and impactful self.
                </p>
                <div className='pricebtgb'>
                  <span>Offline Only</span>
                  <p>INR 2,00,000</p>
                </div>
                <div className="btngro">
                  <a href="courses/image-consulting-transformation-course-india">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#offlineonlyCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img3} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video3)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="transform">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>Transform with Bhavana | Offline course</h3>
                <p>
                  This immersive course is designed to guide you through every aspect of personality development—from mastering confident body language and public speaking to building rapport in client interactions. You’ll also refine your personal style, learning essential styling and makeup skills to carry yourself with poise and polish.
                </p>
                <div className='pricebtgb'>
                  <span>For Offline</span>
                  <p>INR 100,000 + GST</p>
                </div>
                <div className="btngro">
                  <a href="courses/personality-transformation-offline-courses">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#offlineCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img1} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video1)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="transform trnscur">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div className="courses_content">
                <h3>TRANSFORM YOURSELF WITH Bhavana SINGH | ONLINE COURSE</h3>
                <p>
                This immersive course is designed to guide you through every aspect of personality development—from mastering confident body language and public speaking to building rapport in client interactions. You’ll also refine your personal style, learning essential styling and makeup skills to carry yourself with poise and polish.
                </p>
                <div className='pricebtgb'>
                  <span>For Online</span>
                  <p>INR 50,000 + GST</p>
                </div>
                <div className="btngro">
                  <a href="courses/personality-transformation-online-courses">
                    <span>Get Started</span>
                  </a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal"><span>Enrol Now</span></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="courses_image">
                <img src={Img2} alt="" width="100%" />
                <a
                  href="#"
                  onClick={() => handleOpenModal(Video2)}
                  data-bs-toggle="modal"
                  data-bs-target="#videoModal"
                >
                  <img src={Playbtn} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">
                Bhavana Singh
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="offlineCourseModal"
        tabIndex="-1"
        aria-labelledby="offlineCourseModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="formouter">
                <div className="formcontent">
                  <form className="contact_form modalform">
                    <h2>Pay for Offline Course</h2>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-form"
                      onClick={() => handleRazorpayPayment("offline")}
                    >
                      Enrol Now
                    </button>
                  </form>
                </div>
                <div className="forminfo">
                  <a href="tel:919899604722">
                    <img src={Phoneicon} alt="" /> +91-9899604722
                  </a>
                  <a href="mailto:infobhavanasingh@gmail.com">
                    <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="onlineCourseModal"
        tabIndex="-1"
        aria-labelledby="onlineCourseModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="formouter">
                <div className="formcontent">
                  <form className="contact_form modalform">
                    <h2>Pay for Online Course</h2>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-form"
                      onClick={() => handleRazorpayPayment("online")}
                    >
                      Enrol Now
                    </button>
                  </form>
                </div>
                <div className="forminfo">
                  <a href="tel:919899604722">
                    <img src={Phoneicon} alt="" /> +91-9899604722
                  </a>
                  <a href="mailto:infobhavanasingh@gmail.com">
                    <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="offlineonlyCourseModal"
        tabIndex="-1"
        aria-labelledby="offlineonlyCourseModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="formouter">
                <div className="formcontent">
                  <form className="contact_form modalform">
                    <h2>Pay for Only Offline Course</h2>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-form"
                      onClick={() =>
                        handleRazorpayPayment("Only Offline Course")
                      }
                    >
                      Enrol Now
                    </button>
                  </form>
                </div>
                <div className="forminfo">
                  <a href="tel:919899604722">
                    <img src={Phoneicon} alt="" /> +91-9899604722
                  </a>
                  <a href="mailto:infobhavanasingh@gmail.com">
                    <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stylingwithbhavna;
